var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart__wrapper",attrs:{"id":`${_vm.chartData.name}ChartWrapper`}},[_c('h6',{staticClass:"chart__title"},[_vm._v(_vm._s(_vm.chartData.title))]),_c('span',{staticClass:"chart__subtitle"},[_vm._v(_vm._s(_vm.chartData.subtitle))]),_c('div',{staticClass:"chart__canvas_wrapper"},[_c('canvas',{attrs:{"id":_vm.chartData.name}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }